export default __webpack_public_path__ + "static/media/ritual-image-1578433491042.3c26b8f5.jpeg";